import type { ReactElement } from 'react'

export interface SkipLinkProps {
  /** `id` of the element that receives focus — normally the `<main>` landmark. */
  readonly targetId: string
  /** Visible label. Must describe the destination, not the mechanism. */
  readonly label: string
}

/**
 * WCAG 2.2 — 2.4.1 Bypass Blocks.
 *
 * Off-canvas until focused, then anchored to the top-inline-start corner at a
 * pointer target no smaller than 44x44 CSS pixels (2.5.8 Target Size Minimum).
 * Pure presenter: no state, no effects, identical output on server and client.
 */
export function SkipLink({ targetId, label }: SkipLinkProps): ReactElement {
  return (
    <a className="skip-link" href={`#${targetId}`}>
      {label}
    </a>
  )
}
